import React, {
  forwardRef, useEffect, useMemo,
  useState,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import {
  Button,
  Checkbox,
  Dialog, DialogContent, DialogTitle, Grid, IconButton, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Zoom,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';
import RequiredFiled from '../../../../../../utils/RequiredField';
// import ComponentSelectInput from '../../../../../../Common/ComponentSelectInput';
import ComponentTextInput from '../../../../../../Common/ComponentTextinput/ComponentTextInput';
import CustomCheckbox from '../../../../../../Common/ComponentCustomCheckBox';
import { JobScheduleFormInfo, TypesDialogBox } from '../../../utils/types';
import { JobScheduleFields } from '../../../utils/constants';
import { getAnalystMasterStart } from '../../../../../Job/ScreenBidWorkSheetJob/redux/bidWorksheetSlice';
import { RootState } from '../../../../../../redux/rootState';
import { onAddSchedule, onUpdateSchedule } from '../../redux/jobScheduleSlice';
import { CommonDateInput } from '../../../../../../Common/CommonDateInput';
import { addAnalystFormSchema } from '../../utils/validations';
import { getAllEventsWithinDateStart } from '../../../../../calender/redux/calenderSlice';
import { setLoader } from '../../../../../../redux/loaderSlice';
import AddScheduleConfirmationModal from '../AddScheduleConfirmationModal/AddScheduleConfirmationModal';
import { MasterValue } from '../../../../../Job/ScreenBidWorkSheetJob/utils/types';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <Zoom ref={ref} {...props} />);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 340,
    },
  },
};

function DialogBoxAddAnalyst({
  show, setOpenFrom, unitId, unitEditData,
}: TypesDialogBox): JSX.Element {
  const [error, setError] = useState('');
  const [analystError, setAnalystError] = useState('');
  const [payloadData, setPayloadData] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [personName, setPersonName] = useState<MasterValue[]>([]);
  const {
    control, formState: { errors }, setValue, handleSubmit, watch, getValues,
  } = useForm<JobScheduleFormInfo>({
    resolver: yupResolver(addAnalystFormSchema as unknown as ObjectSchema<JobScheduleFormInfo>),
  });
  const dispatch = useDispatch();
  const { analystList } = useSelector((state: RootState) => state.bidsReducer);
  const { isLoading, eventListWithinDate } = useSelector((state: RootState) => state.CalenderReducer);
  // const anId = watch(JobScheduleFields.analyst);

  const getEvents = () => {
    // const AnalystId = getValues(JobScheduleFields.analyst);
    const AnalystId = personName.map((p) => p.Value).join(',');
    const StartDate = dayjs(getValues(JobScheduleFields.startDate)).format('DD-MM-YYYY');
    const EndDate = dayjs(getValues(JobScheduleFields.endDate)).format('DD-MM-YYYY');

    const payload = {
      AnalystId,
      StartDate,
      EndDate,
    };
    dispatch(getAllEventsWithinDateStart(payload));
  };

  // const analystName = useMemo(() => {
  //   if (analystList?.length > 0 && anId) {
  //     return analystList?.find((item) => item?.Value === anId)?.Text;
  //   } return '';
  // }, [analystList, anId]);
  useEffect(() => {
    if (personName?.length > 0) {
      setAnalystError('');
    }
  }, [personName]);

  const onSubmit = (values: JobScheduleFormInfo) => {
    if (personName?.length === 0) {
      setAnalystError('Analyst is required');
      return;
    }
    const analNames = personName.map((p) => p.Value).join(',');
    const isMultiAnals = personName?.length > 1;
    const formPayload = {
      IsAssignedMultiple: isMultiAnals,
      AnalystId: isMultiAnals ? personName[0]?.Value : analNames || '',
      AnalystIds: analNames || '',
      UnitId: unitId || '',
      StartDate: dayjs(values?.startDate).format('DD-MM-YYYY'),
      EndDate: dayjs(values?.endDate).format('DD-MM-YYYY'),
      PoNumber: values?.po || '',
      Notes: values?.notes || '',
      Equipment: !!values?.equipmentCheckBox,
      Flux: !!values?.fluxCheckBox,
      SmallJob: !!values?.smallJobCheckBox,
      DayBefore: !!values?.dayBeforeCheckBox,
      NightJob: !!values?.nightJobCheckBox,
      NextDay: !!values?.nextDayCheckBox,
      DoNotMove: !!values?.doNotMoveCheckBox,
    };
    if (unitEditData?.ScheduleDetails?.ScheduleId) {
      const updatePayload = {
        IsAssignedMultiple: isMultiAnals,
        AnalystId: isMultiAnals ? personName[0]?.Value : analNames || '',
        AnalystIds: analNames || '',
        UnitId: unitId || '',
        StartDate: dayjs(values?.startDate).format('DD-MM-YYYY'),
        EndDate: dayjs(values?.endDate).format('DD-MM-YYYY'),
        PoNumber: values?.po || '',
        Notes: values?.notes || '',
        Equipment: !!values?.equipmentCheckBox,
        Flux: !!values?.fluxCheckBox,
        SmallJob: !!values?.smallJobCheckBox,
        DayBefore: !!values?.dayBeforeCheckBox,
        NightJob: !!values?.nightJobCheckBox,
        NextDay: !!values?.nextDayCheckBox,
        DoNotMove: !!values?.doNotMoveCheckBox,
        ScheduleId: unitEditData?.ScheduleDetails?.ScheduleId ?? '',
      };

      setPayloadData(updatePayload);
      // dispatch(onUpdateSchedule(updatePayload));
    } else {
      setPayloadData(formPayload);
      // dispatch(onAddSchedule(formPayload));
    }
    getEvents();
    // setOpenFrom();
  };

  const handleSave = () => {
    setShowConfirmation(false);
    if (unitEditData?.ScheduleDetails?.ScheduleId) {
      dispatch(onUpdateSchedule(payloadData));
    } else {
      dispatch(onAddSchedule(payloadData));
    }
    setPayloadData({});
    setOpenFrom();
  };

  useEffect(() => {
    if (eventListWithinDate?.[0]?.Events?.length > 0 && Object.keys(payloadData)?.length > 0) {
      setShowConfirmation(true);
    } else if (eventListWithinDate?.[0]?.Events?.length === 0 && Object.keys(payloadData)?.length > 0) {
      handleSave();
    }
  }, [eventListWithinDate]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  useEffect(() => {
    dispatch(getAnalystMasterStart());
  }, []);

  const resetValues = () => {
    setPersonName([]);
    setValue(JobScheduleFields.analyst, '');
    setValue(JobScheduleFields.po, '');
    setValue(JobScheduleFields.notes, '');
    setValue(JobScheduleFields.equipmentCheckBox, unitEditData?.IsEquipment);
    setValue(JobScheduleFields.fluxCheckBox, unitEditData?.IsFlux);
    setValue(JobScheduleFields.smallJobCheckBox, unitEditData?.IsSmallJob);
    setValue(JobScheduleFields.dayBeforeCheckBox, '');
    setValue(JobScheduleFields.nightJobCheckBox, '');
    setValue(JobScheduleFields.nextDayCheckBox, '');
    setValue(JobScheduleFields.doNotMoveCheckBox, '');
    setValue(JobScheduleFields.startDate, dayjs());
    setValue(JobScheduleFields.endDate, dayjs());
    setPayloadData({});
  };
  useEffect(() => {
    if (unitEditData?.ScheduleDetails?.AnalystId) {
      if (unitEditData?.ScheduleDetails.StartDate) {
        const StartDate = (dayjs(unitEditData?.ScheduleDetails.StartDate, 'DD-MM-YYYY'));
        if (StartDate) {
          setValue(JobScheduleFields.startDate, StartDate);
        }
      }
      if (unitEditData?.ScheduleDetails.EndDate) {
        const EndDate = (dayjs(unitEditData?.ScheduleDetails.EndDate, 'DD-MM-YYYY'));
        if (EndDate) {
          setValue(JobScheduleFields.endDate, EndDate);
        }
      }
      if (unitEditData?.ScheduleDetails?.AnalystId) {
        setValue(JobScheduleFields.analyst, unitEditData?.ScheduleDetails?.AnalystId);
      }
      setValue(JobScheduleFields.po, unitEditData?.ScheduleDetails?.PoNumber);
      setValue(JobScheduleFields.notes, unitEditData?.ScheduleDetails?.Notes);
      setValue(JobScheduleFields.dayBeforeCheckBox, unitEditData?.ScheduleDetails?.DayBefore);
      setValue(JobScheduleFields.nightJobCheckBox, unitEditData?.ScheduleDetails?.NightJob);
      setValue(JobScheduleFields.nextDayCheckBox, unitEditData?.ScheduleDetails?.NextDay);
      setValue(JobScheduleFields.doNotMoveCheckBox, unitEditData?.ScheduleDetails?.DoNotMove);
      setValue(JobScheduleFields.equipmentCheckBox, unitEditData?.ScheduleDetails?.Equipment);
      setValue(JobScheduleFields.fluxCheckBox, unitEditData?.ScheduleDetails?.Flux);
      setValue(JobScheduleFields.smallJobCheckBox, unitEditData?.ScheduleDetails?.SmallJob);
    } else {
      resetValues();
      if (unitEditData?.AnalystId) {
        setValue(JobScheduleFields.analyst, unitEditData?.AnalystId);
        setValue(JobScheduleFields.po, unitEditData?.PoNumber);
      }
    }
  }, [unitEditData, show]);

  const onCloseModal = () => {
    resetValues();
    setOpenFrom();
  };
  const startDate = watch(JobScheduleFields.startDate);
  const endDate = watch(JobScheduleFields.endDate);
  const buttonDisabled = useMemo(() => {
    if (endDate && startDate) {
      const isErr = endDate?.isBefore(startDate);
      if (isErr) {
        setError('The start date cannot occur after the end date.');
        return isErr;
      }

      let currentDate = dayjs(startDate);
      let hasWeekend = false;
      while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
        const day = currentDate.day(); // 0 = Sunday, 6 = Saturday
        if (day === 0 || day === 6) {
          hasWeekend = true;
          break;
        }
        currentDate = currentDate.add(1, 'day');
      }
      if (hasWeekend) {
        setError('NOTE: Some of the days within the selected dates fall on weekends.');
        return false;
      }

      setError('');
      return isErr;
    } setError('');
    return false;
  }, [endDate, startDate]);

  const modalHeaderText = useMemo(() => {
    if (unitEditData?.ScheduleDetails?.AnalystId) {
      return 'Edit Schedule';
    }
    return 'Add Schedule';
  }, [show]);
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;

    // Ensure value is string[] (it always will be in multiple mode)
    const selectedValues = typeof value === 'string' ? [value] : value;

    // Map strings back to objects
    const selectedObjects = selectedValues.map((v) => {
      const obj = analystList.find((n) => n.Value === v);
      if (!obj) throw new Error(`Value ${v} not found in options`);
      return obj;
    });

    if ((selectedObjects.length === analystList.length - 1) && (personName?.length === analystList.length)) {
      setPersonName([]);
    } else {
      setPersonName(selectedObjects);
    }
  };

  return (
    <div>
      <Dialog
        maxWidth="lg"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={onCloseModal}
      >
        <DialogTitle className="dialogTitle_style">
          <div className="dialogTitle_style_div">
            <div className="customerInfo">{modalHeaderText}</div>
          </div>
          <IconButton
            aria-label="close"
            onClick={onCloseModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="dialogContent_style">
          <div className="dialogContent_style_div ">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                <Grid item md={7} sm={12} xs={12}>
                  <Grid container spacing={2} className="rightBorder">
                    <Grid item md={10} sm={6} xs={12}>
                      <div className="div_label_text">
                        <label className="label_Style_Customer">
                          Analyst
                          <RequiredFiled />
                        </label>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          displayEmpty
                          sx={{ height: 36, fontSize: '14px' }}
                          value={personName.map((p: { Value: string }) => p.Value)}
                          onChange={handleChange}
                          input={<OutlinedInput placeholder="Analyst" />}
                          MenuProps={MenuProps}
                          renderValue={(selected) => {
                            const selectedObjects = analystList.filter((n) => selected.includes(n.Value));
                            return selectedObjects.length === 0
                              ? <span style={{ color: '#a09f9fff' }}>Analyst</span>
                              : selectedObjects.map((s) => s.Text).join(', ');
                          }}
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          {analystList.map((name) => (
                            <MenuItem
                              key={name.Value}
                              value={name.Value}
                              sx={{
                                height: 36,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '3px',
                                paddingLeft: 0,
                                '&:hover': {
                                  backgroundColor: '#f0f9f4', // light green hover
                                },

                                '&.Mui-selected': {
                                  backgroundColor: 'rgb(229, 246, 237)', // when selected
                                  fontWeight: 'bold',
                                  '&:hover': {
                                    backgroundColor: '#c0e8c0', // hover on selected
                                  },
                                },
                              }}
                            >
                              <Checkbox
                                checked={personName.some((p: { Value: string }) => p.Value === name.Value)}
                                sx={{
                                  color: '#9e9e9e',
                                  '&.Mui-checked': {
                                    color: '#00a751', // green when checked
                                  },
                                  '& .MuiSvgIcon-root': {
                                    fontSize: 20, // checkbox size
                                  },
                                }}
                              />
                              <ListItemText
                                primary={name.Text}
                                primaryTypographyProps={{ fontSize: '14px' }}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                        {analystError.length > 0 && (
                          <div className="add_schedule_error">
                            <p>{analystError}</p>
                          </div>
                        )}
                        {/* <ComponentSelectInput
                          name={JobScheduleFields.analyst}
                          control={control}
                          errors={errors}
                          size="small"
                          required
                          entries={analystList}
                        /> */}
                      </div>
                    </Grid>
                    <Grid item md={5} sm={12} xs={12}>
                      <div className="div_label_text">
                        <label className="label_Style_job">
                          Start Date
                          <RequiredFiled />
                        </label>
                        <CommonDateInput
                          control={control}
                          errors={errors}
                          name={JobScheduleFields.startDate}
                        />
                      </div>
                    </Grid>
                    <Grid item md={5} sm={12} xs={12}>
                      <div className="div_label_text">
                        <label className="label_Style_job">
                          End Date
                          <RequiredFiled />
                        </label>
                        <CommonDateInput
                          control={control}
                          errors={errors}
                          name={JobScheduleFields.endDate}
                        />
                      </div>
                    </Grid>
                    {error.length > 0 && (
                    <Grid item md={10} sm={12} xs={12}>
                      <div className="add_schedule_error">
                        <p>{error}</p>
                      </div>
                    </Grid>
                    )}
                    <Grid item md={10} sm={12} xs={12}>
                      <div className="div_label_text">
                        <label className="label_Style_job">PO #</label>
                        <ComponentTextInput
                          control={control}
                          className="nonCapitalizeField"
                          name={JobScheduleFields.po}
                          size="small"
                          inputProps={{ maxLength: 25 }}
                          id={JobScheduleFields.po}
                          errors={errors}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={5} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item md={8} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.equipmentCheckBox}
                        control={control}
                        label="Equipment"
                      />
                    </Grid>
                    <Grid item md={4} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.nightJobCheckBox}
                        control={control}
                        label="Night Job"
                      />
                    </Grid>
                    <Grid item md={8} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.fluxCheckBox}
                        control={control}
                        label="Flux"
                      />
                    </Grid>
                    <Grid item md={4} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.nextDayCheckBox}
                        control={control}
                        label="Next Day"
                      />
                    </Grid>
                    <Grid item md={8} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.smallJobCheckBox}
                        control={control}
                        label="Small job"
                      />
                    </Grid>
                    <Grid item md={4} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.doNotMoveCheckBox}
                        control={control}
                        label="Do not Move"
                      />
                    </Grid>
                    <Grid item md={8} sm={12} xs={12} className="rightSideContent">
                      <CustomCheckbox
                        name={JobScheduleFields.dayBeforeCheckBox}
                        control={control}
                        label="Day Before"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <div className="div_label_text">
                    <label className="label_Style_job">Notes</label>
                    <ComponentTextInput
                      control={control}
                      className="nonCapitalizeField"
                      name={JobScheduleFields.notes}
                      id={JobScheduleFields.notes}
                      multiline
                      inputProps={{ maxLength: 2056 }}
                      size="small"
                      rowSize={8}
                    />
                  </div>
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <div className="save_and_next_div">
                    <div>
                      <Button className="button_cancel" onClick={onCloseModal}>Cancel</Button>
                    </div>
                    <div className="button_margin_left">
                      <Button disabled={buttonDisabled} type="submit" className="button_save_and_next">Save</Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <AddScheduleConfirmationModal
        show={showConfirmation}
        setOpenFrom={() => setShowConfirmation(false)}
        callback={handleSave}
        // analystName={analystName || ''}
        analystName=""
      />
    </div>
  );
}

export default DialogBoxAddAnalyst;
